<section class="legal-shell">
  <div class="legal-card">
    <p class="eyebrow">Page publique</p>
    <h1>Suppression des donnees</h1>
    <p class="lead">
      Pour demander la suppression des donnees de votre compte AfriFood, envoyez un email a
      <a href="mailto:support.afrifood@afrimoov.com">support.afrifood@afrimoov.com</a>.
    </p>

    <div class="section">
      <h2>Contenu attendu dans l'email</h2>
      <ul>
        <li>Objet : <strong>Demande de suppression des donnees</strong>.</li>
        <li>L'adresse email utilisee pour votre compte AfriFood.</li>
        <li>Votre nom ou nom affiche dans l'application.</li>
        <li>Tout element utile permettant d'identifier le compte.</li>
      </ul>
    </div>

    <div class="section">
      <h2>Suite de la procedure</h2>
      <ul>
        <li>Le support peut vous demander de confirmer que vous etes bien proprietaire du compte.</li>
        <li>Apres verification, la demande sera traitee dans un delai raisonnable.</li>
        <li>Certaines donnees peuvent etre conservees pour la prevention de la fraude ou pour des obligations legales.</li>
      </ul>
    </div>

    <div class="section">
      <h2>Contact support</h2>
      <p>
        Email:
        <a href="mailto:support.afrifood@afrimoov.com">support.afrifood@afrimoov.com</a>
      </p>
    </div>

    <div class="actions">
      <a routerLink="/privacy-policy">Voir la politique de confidentialite</a>
      <a routerLink="/login">Retour a la connexion admin</a>
    </div>
  </div>
</section>
